export const buildSiteSavePayload = (site) => {
  if (!site) return null;

  return {
    id: site.siteId ?? null,
    name: site.siteName ?? null,
    type: site.type ?? null,
    status: site.status ?? null,
    ownership: site.ownership ?? null,
    lat: site.lat ?? null,
    lon: site.lon ?? null,
    addressOne: site.addressOne ?? null,
    addressTwo: site.addressTwo ?? null,
    postalCode: site.postalCode ?? null,
    city: site.city ?? null,
    state: site.state ?? null,
    stateAbbr: site.stateAbbr ?? null,
    country: site.country ?? null,
    countryCode: site.countryCode ?? null,
    businessRegionName: site.businessRegionName ?? null,
    geoRegion: site.geoRegion ?? null,
    recordDateTimeStamp: site.recordDateTimeStamp ?? null,
    siteNote:
      {
        note: site.note,
        siteId: site.siteId,
      } ?? null,
  };
};
